import React from 'react';
import classes from './TunnelSignal.module.css';
import tunnelOpen from '../../assets/tunnel_open.svg';
import tunnelClosedLane from '../../assets/tunnel_closed_lane.svg';
import tunnelClosed from '../../assets/tunnel_closed.svg';

const TUNNEL_CODES = {
    0: tunnelOpen,
    1: tunnelClosed,
    2: tunnelClosedLane,
    5: tunnelClosed,
};

const TunnelSignal = (props) => {
    const {statusValue, statusText, title} = props;

    return (
        <div className={classes.Signal}>
            {title}
            <div className={classes.SignalContainer}>
                <img
                    className={classes.Signal}
                    src={TUNNEL_CODES[statusValue]}
                    alt={statusText}
                    title={statusText}
                />
            </div>
        </div>
    );
};

export default TunnelSignal;
